module.exports = __webpack_public_path__ + "static/thy1-cfdafd1cad70c5a5c00c61f2ac0270c9.png";